module.exports = __webpack_public_path__ + "static/media/menu.064c474b.svg";